import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React__default, { Component } from 'react';
import styled from 'styled-components';
import Text from '../components/text/text.component.js';
import SingleFaq from './single-faq.component.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var Div = styled.div.withConfig({
  displayName: "landing-faqcomponent__Div",
  componentId: "sc-1hshceh-0"
})(["padding-top:96px;padding-bottom:96px;@media screen and (max-width:768px){padding-top:48px;padding-bottom:48px;}"]);
var Container = styled.div.withConfig({
  displayName: "landing-faqcomponent__Container",
  componentId: "sc-1hshceh-1"
})(["opacity:1;transition:opacity 0.3s;display:block;&.hidden{position:absolute;opacity:0;left:0;right:0;width:70vw;@media screen and (max-width:768px){width:80vw;}}&:not(.hidden){z-index:2;}.accordion-list{list-style:none;margin:auto;padding:0;background-color:#fff;width:50%;min-width:500px;max-width:1000px;border-radius:0.4rem;overflow:hidden;box-shadow:0 0 0.8rem 0.1rem rgba(15,72,179,0.06),0 20px 30px -10px rgba(15,72,179,0.2);}.accordion-list__item + .accordion-list__item{border-top:1px solid rgba(0,0,0,0.2);}.accordion-item--opened .accordion-item__icon{transform:rotate(180deg);}.accordion-item--opened .accordion-item__inner{max-height:700px;transition-timing-function:linear;transition-duration:0.5s;transition-property:max-height;}.accordion-item--opened .accordion-item__content{opacity:1;transform:translateY(0);transition-duration:0.2s;transition-property:opacity,transform;}.dark{color:var(--white) !important;background-color:var(--main) !important;border-color:var(--white-01) !important;}.big{font-size:34px !important;margin:0 !important;height:130px;line-height:1.2 !important;align-items:center;display:flex;}.accordion-item__line{padding:0rem 1.2rem 0 0;display:flex;justify-content:space-between;align-items:center;z-index:2;position:relative;}.accordion-item__line:hover{cursor:pointer;}.accordion-item__title{font-size:14px;line-height:28px;font-family:stolzl,Arial;font-weight:500;color:var(--main);padding-right:20px;width:calc(100% - 20px);margin:30px 0 30px;}.accordion-item__icon{width:24px;height:24px;transition:transform 0.3s ease-in-out;background-size:contain;background-repeat:no-repeat;}.accordion-item__inner{max-height:0;overflow:hidden;text-transform:cubic-bezier(0.95,0.05,0.795,0.035);transition-duration:0.5s;transition-property:max-height;z-index:1;position:relative;}.accordion-item__content{opacity:0;transform:translateY(-1rem);transition-timing-function:linear,linear;transition-duration:0.1s;transition:opacity,transform;transition-delay:0.1s;padding:0 0 24px 0;margin-bottom:10px;}.accordion-item__paragraph-big{max-width:820px;}.accordion-item-dark .accordion-item__paragraph-big{color:var(--dark-gray-1);}.accordion-item-light .accordion-item__paragraph-big{color:var(--light-gray-1);}.accordion-item-dark{border-bottom:1px solid;border-color:var(--dark-gray-5);}.accordion-item-light{border-bottom:1px solid;border-color:var(--light-gray-5);}@media screen and (max-width:1200px){.accordion-item--opened .accordion-item__inner{max-height:100rem;}.accordion-item__content{padding:0px 0px 24px;}}@media screen and (max-width:768px){.big{font-size:24px !important;}}"]);
var FullContainer = styled.div.withConfig({
  displayName: "landing-faqcomponent__FullContainer",
  componentId: "sc-1hshceh-2"
})(["width:100%;"]);
var TextTitle = styled(Text).withConfig({
  displayName: "landing-faqcomponent__TextTitle",
  componentId: "sc-1hshceh-3"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:48px;line-height:57px;}"]);
var TextDescription = styled(Text).withConfig({
  displayName: "landing-faqcomponent__TextDescription",
  componentId: "sc-1hshceh-4"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:20px;line-height:28px;}"]);
var LandingFaq = /*#__PURE__*/function (_Component) {
  _inherits(LandingFaq, _Component);
  var _super = _createSuper(LandingFaq);
  function LandingFaq(props) {
    var _this;
    _classCallCheck(this, LandingFaq);
    _this = _super.call(this, props);
    _this.state = {
      activeFaq: []
    };
    return _this;
  }
  _createClass(LandingFaq, [{
    key: "parseLink",
    value: function parseLink(text, link, LinkComponent) {
      var t = text.split("*link*");
      var array = [];
      t.map(function (p, index) {
        if (index != 0 && index % 2 != 0 && link) {
          if (!link.includes("http") && !link.includes("@") && LinkComponent) {
            array.push( /*#__PURE__*/React__default.createElement(LinkComponent, {
              to: link,
              className: "link-style link-hover",
              key: index,
              title: p,
              style: {
                textDecoration: "none",
                color: "var(--green)"
              }
            }, p));
          } else array.push( /*#__PURE__*/React__default.createElement("a", {
            href: link.includes("@") ? "mailto:" + link : link,
            target: link.includes("@") ? "_self" : "_blank",
            className: "link-style link-hover",
            key: index,
            rel: "noopener",
            title: p,
            style: {
              textDecoration: "none",
              color: "var(--green)"
            }
          }, p));
        } else {
          array.push(p);
        }
      });
      return array;
    }
  }, {
    key: "openFaq",
    value: function openFaq(index) {
      var newActiveFaq = this.state.activeFaq || [];
      if (newActiveFaq.includes(index)) {
        newActiveFaq = newActiveFaq.filter(function (item) {
          return item !== index;
        });
        this.setState({
          activeFaq: newActiveFaq
        });
      } else {
        newActiveFaq.push(index);
        this.setState({
          activeFaq: newActiveFaq
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        title = _this$props.title,
        faqs = _this$props.faqs,
        footer = _this$props.footer,
        style = _this$props.style,
        link = _this$props.link,
        LinkComponent = _this$props.LinkComponent;
      var arrayOfFaqs = faqs.map(function (faq, index) {
        return /*#__PURE__*/React__default.createElement(SingleFaq, {
          big: true,
          index: index,
          key: index,
          openFaq: function openFaq(index) {
            return _this2.openFaq(index);
          },
          activeFaq: _this2.state.activeFaq,
          title: faq.title,
          content: faq.content,
          mail: faq.mail ? faq.mail : ""
        });
      });
      return /*#__PURE__*/React__default.createElement(Div, {
        style: _objectSpread({
          minHeight: "unset"
        }, style)
      }, /*#__PURE__*/React__default.createElement(FullContainer, null, /*#__PURE__*/React__default.createElement(Container, {
        className: this.props.hidden ? "hidden" : "",
        style: {
          maxWidth: "754px",
          margin: "auto"
        }
      }, /*#__PURE__*/React__default.createElement(TextTitle, {
        fontFamily: "euclid",
        type: "display",
        fontSize: "large",
        style: {
          marginBottom: "34px"
        }
      }, title), arrayOfFaqs, /*#__PURE__*/React__default.createElement(TextDescription, {
        fontFamily: "euclid",
        type: "heading",
        fontSize: "medium",
        style: {
          marginTop: "34px"
        }
      }, this.parseLink(footer, link, LinkComponent)))));
    }
  }]);
  return LandingFaq;
}(Component);
export { LandingFaq as default };